import Vue from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import Popover from 'vue-js-popover'
import VueResource from 'vue-resource'
import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(Vuelidate)
Vue.use(Popover)
Vue.use(VueResource);
Vue.use(VueSweetalert2);


import AOS from 'aos'
import 'aos/dist/aos.css'

new Vue({
  el: '#app',
  components: {
    'app': App
  },
  created () {
    AOS.init()
  }
})



// WEBPACK FOOTER //
// ./resources/assets/vue/apps/App/main.js